/**
 * @ui-ng-university-text
 */
require('angular-sanitize');
module.exports = 'ui-ng-university-text';
angular
  .module('ui-ng-university-text', ['ngSanitize'])
  .provider(
    'universityTextConfig',
    /*@ngInject*/ function () {
      const DEFAULTS = {
        disableTrustHtml: true,
        disableCustomHref: false,
        isHybridApp: false,
        target: '_system',
        addUniversityStyles: true
      };
      let config = angular.merge({}, DEFAULTS);
      const write =
        (this.write =
        this.configure =
          function write(customConfig) {
            config = angular.merge(DEFAULTS, customConfig);
          });
      const activate = (this.activate = function activate(customConfig) {
        write(customConfig);
      });
      const read = (this.read = function read() {
        return config;
      });
      activate({});
      this.$get = function $get_universityTextConfig() {
        return {
          activate: activate,
          write: write,
          configure: write,
          read: read
        };
      };
    }
  )
  .decorator(
    'ngBindHtmlDirective',
    /*@ngInject*/ function ($delegate, $compile, $parse, $sce, universityTextConfig) {
      const directive = $delegate[0];
      // Overwriting Angular ngBindHtml compile function with custom changes
      // ANGULAR 1.5.0 CODE COPY
      // https://github.com/angular/angular.js/blob/master/src/ng/directive/ngBind.js
      // @purpose Customize ng-bind-html to compile directives and ability to custom parse html that is being rendered.
      // @change SAFETY: Allow html safety based on global config.
      // @change CUSTOM Parser: Allow html to be parsed using a custom function (parseHtmlFn) before being injected to DOM
      // @change COMPILE : Run additional $compile to enable any directives in dynamic html.
      directive.compile = function ngBindHtmlCompile(tElement, tAttrs) {
        //Compile
        const ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
        let htmlTemplate = '';
        const config = universityTextConfig.read();
        const updateTemplate = function (scope) {
          htmlTemplate = ngBindHtmlGetter(scope);
          if (typeof config.parseHtmlFn === 'function') {
            htmlTemplate = config.parseHtmlFn(htmlTemplate);
          } else if (!config.disableTrustHtml) {
            htmlTemplate = $sce.getTrustedHtml(htmlTemplate);
          }
          return htmlTemplate ? $compile('<span>' + htmlTemplate + '</span>')(scope) : '';
        };
        const ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function getStringValue(value) {
          return (value || '').toString();
        });
        $compile.$$addBindingClass(tElement);
        return function ngBindHtmlLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBindHtml);
          scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
            if (config.addUniversityStyles) {
              element.addClass('university-tags university-text');
            }
            element.html(updateTemplate(scope));
          });
        };
      };
      return $delegate;
    }
  )
  .directive('href', function external_link(universityTextConfig, $location, $state, ngTouchEventFunctionService) {
    'use strict';
    const config = universityTextConfig.read();
    const urlRegex = /(https?:\/\/[^\s]*)/; //match all links with http:// or https:// not dummy links
    const otherRegex = /(mailto:|tel:|geo:|sms:|maps:)/; //match all links with http:// or https:// not dummy links
    const currentDomainUrl = $location.protocol() + '//' + $location.host();
    const domainRegex = new RegExp('\\b' + currentDomainUrl.replace(/\\/g, '\\\\') + '\\b', 'gi');
    const angularUrlHashs = ['/#!/', '/#/'];

    const isAppInternalLink = function isAppInternalLink(link) {
      return domainRegex.test(link) && /\/#/.test(link);
    };

    const reformatInternalLink = function reformatInternalLink(link) {
      let formattedInternalLink = '';

      angularUrlHashs.forEach(function (separator) {
        if (link.indexOf(separator) !== -1) {
          formattedInternalLink = angularUrlHashs[1] + link.split(separator)[1];
        }
      });

      return formattedInternalLink;
    };

    const addTouchEvent = function (ele, link, isSystem) {
      const mobileEventListener = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(link, isSystem ? '_system' : config.target);
      };

      ele.removeAttr('target');
      ele.removeAttr('onclick');
      ele.attr('href', 'javascript:void(0)');

      const nodeEl = _.first(ele);
      nodeEl.addEventListener('click', mobileEventListener, false);
      nodeEl.addEventListener('touchstart', mobileEventListener, false);
    };

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        // disable the angular re-write because it is breaking normal links
        //
        if (attrs['allow-static-href']) {
          return false;
        }

        const el = element[0];
        if (el.tagName != 'A') {
          return false;
        }

        const link = attrs['href'];
        if (isAppInternalLink(link)) {
          element.removeAttr('target');

          if (config.isHybridApp) {
            element.removeAttr('href');
            ngTouchEventFunctionService.touchEventFunction(reformatInternalLink(link), element);
          } else {
            element.attr('href', reformatInternalLink(link));
          }
        } else {
          if (urlRegex.test(link) && !config.disableCustomHref) {
            element.attr('target', '_blank');
            element.attr('rel', 'external');

            if (config.isHybridApp) {
              addTouchEvent(element, link);
            }

            //Add default accessibility screen reader only text (opens new window)
            element.append('<span class="hide-read show-ax"> (opens new window)</span>');
          } else if (otherRegex.test(link) && config.isHybridApp) {
            element.attr('rel', 'external');
            addTouchEvent(element, link, true);
          }
        }
      }
    };
  });

require('./services/touch_event_function_service');



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-text/src/main.es.js